<template>
  <div class="pwmat-trial-download-background">
    <div class="pwmat-trial-download-banner">
      <div class="pwmat-trial-download-container">
        <div class="pwmat-trial-download-banner-title">软件下载</div>
      </div>

      <img
        class="pwmat-trial-download-banner-img"
        src="../../assets/about/banner.png"
      />
    </div>
    <div class="pwmat-trial-download-container">
      <div class="pwmat-trial-download-content">
        <div class="pwmat-trial-download-content-title">
          <div class="pwmat-trial-download-content-title-text">
            server.py服务安装方法
          </div>
          <div class="pwmat-trial-download-line"></div>
        </div>
        <div class="pwmat-trial-download-content-info">
          <p class="pwmat-trial-download-content-info-text">
            对于超算中心或者大规模集群用户，可以采用启动server.py服务认证LICENSE。安装运行server.py服务步骤如下：
          </p>
        </div>

        <div>
          <pre class="pwmat-trial-download-pre">
一.配置python环境
server.py服务基于python语言开发，需要保证python>=3.9.13。如果用户服务器已经安装python环境并且python版本满足要求，可以忽略本步，
直接跳到server.py服务安装。如果用户服务器上python环境不满足要求，可以通过Anaconda或Miniconda来配置必须要的python环境，推荐使用
Miniconda来配置，因为Miniconda安装包比较小，可以快速下载。
1.下载安装Miniconda3：
------------------------------------------------------
从Miniconda <a href="https://docs.anaconda.com/free/miniconda/">官网下载</a> Miniconda3，上传到服务器，
然后运行“sh Miniconda3-latest-Linux-x86_64.sh”命令安装。建议安装最后步骤让选择是否在启动时进入base环境，选择no，
以免影响服务器上已有的python环境，可以通过步骤2的方法加载Miniconda3环境。

2.设置环境变量加载Miniconda3：
-----------------------------------------------------
export PATH=/xxx/bin:$PATH
export LD_LIBRARY_PATH=/xxx/lib:$LD_LIBRARY_PATH
source /xxx/etc/profile.d/conda.sh
注：xxx表示miniconda安装路径。

3.创建及启动环境：
-----------------------------------------------------
conda create -n pwmat_license python=3.9.13 -y
conda activate pwmat_license

二.安装server.py服务
1. 下载LICENSE证书服务安装包：
------------------------------------------------------
如果服务器可以联网，通过wget命令直接下载到服务器：
wget http://www.pwmat.com/pwmat-resource/mstation-download/PWmatLICENSE.zip
或点击下面链接，下载到个人电脑，然后上传到服务：
<a href="https://www.pwmat.com/pwmat-resource/mstation-download/PWmatLICENSE.zip">PWmatLICENSE.zip</a>

2. 解压安装包，并通过pip安装依赖的python库：
------------------------------------------------------
unzip PWmatLICENSE.zip
cd PWmatLICENSE
pip install -r requirements.txt -y

3. 产生pwmat_hdwkey文件，并将其发送给销售人员或将其以邮件附件的形式发送到support@pwmat.com。产生该文件需运行命令如下：
------------------------------------------------------
python server.py --get-hardware-key

4. 将返回的证书文件pwmat.lic和pwmat.sig上传到服务器PWmatLICENSE文件夹下
-----------------------------------------------------

5. 修改PWmatLICENSE文件夹下的config.json，文件内容如下：
------------------------------------------------------
{
    "DATABASE": "pwmat.db",
    "TABLE": "client_info",
    "LOG": "log.txt",
    "IP": "10.0.0.2",
    "PORT": 50001,
    "MAX_CONNECTIONS": 1000,
    "LICENSE": "pwmat.lic",
    "SIGNATURE": "pwmat.sig",
    "ALLOWED_USERS":[
        "user1",
        "user2"
    ]
}

”DATABASE“为存储作业信息数据库名称；”TABLE“为数据表名称；”LOG“为存储日志文件名称；
”IP“为server.py运行服务器的ip地址(此地址一般为内网地址，保证运行PWmat的节点ip可以与该ip互通即可)；
”PORT“为服务的端口号，可以根据自己的情况更改，一般使用默认50001即可；
”LICENSE“为证书文件名；”SIGNATURE“为签名文件名；
”ALLOWED_USERS“为超算或者服务器上允许使用PWmat的用户名。如果“ALLOWED_USERS”设置为空，则不对用户做限制，所有用户都可以使用PWmat。

6.修改启动脚本script.sh文件,将3，4，5行的xxx替换为miniconda3的安装路径：
------------------------------------------------------

7.运行server.py，提交PWmat任务时需要保证该服务处于运行状态：
------------------------------------------------------
./script.sh start

<p :style="{ color: 'red' }">注意:a.请使用./script --help查看帮助信息。</p>

7.运行PWmat时，需要在PWmat后面加上-host参数，并在-host参数后加上config.json文件中的"IP"和”PORT“值，例如下面所示：
------------------------------------------------------
<p :style="{ color: 'red' }">mpirun -np 4 PWmat -host 10.0.0.2 50001</p>

         </pre>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PWmatUpdateFunc",
  data() {
    return {};
  },
  methods: {
    toPWmatUpdateFunc() {},
  },
};
</script>

<style scoped>
.pwmat-trial-download-container {
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
  margin-right: auto;
  margin-left: auto;
}
.pwmat-trial-download-background {
  margin-top: 70px;
}
.pwmat-trial-download-banner {
  overflow: hidden;
}
.pwmat-trial-download-banner-title {
  font-size: 24px;
  font-family: PingFangSC-Semibold, sans-serif;
  font-weight: 600;
  color: rgba(255, 255, 255, 1);
  line-height: 50px;
  position: absolute;
  margin-top: 60px;
}
.pwmat-trial-download-banner-img {
  min-width: 100%;
  height: 165px;
}
.pwmat-trial-download-content {
  margin-top: 30px;
  margin-bottom: 90px;
}
.pwmat-trial-download-content-title {
  padding-top: 50px;
}
.pwmat-trial-download-content-title-text {
  font-size: 30px;
  font-family: PingFangSC-Medium, sans-serif;
  font-weight: 500;
  color: rgba(73, 145, 201, 1);
  line-height: 50px;
}
.pwmat-trial-download-content-note-text {
  font-size: 16px;
  font-family: PingFangSC-Regular, sans-serif;
  font-weight: 400;
  color: rgba(79, 76, 77, 1);
  line-height: 25px;
  margin-bottom: 0px;
}
.pwmat-trial-download-content-info {
  margin-top: 40px;
}
.pwmat-trial-download-content-info-text {
  font-size: 16px;
  font-family: PingFangSC-Regular, sans-serif;
  font-weight: 400;
  color: rgba(79, 76, 77, 1);
  line-height: 25px;
}
.pwmat-trial-download-line {
  height: 1px;
  background: rgba(240, 240, 240, 1);
  margin-top: 8px;
}

.pwmat-trial-download-introduce-table {
  width: 100%;
  border: 1px solid rgba(240, 240, 240, 1);
}
.pwmat-trial-download-introduce-th {
  background: rgba(73, 145, 201, 1);
  height: 45px;
}
.pwmat-trial-download-introduce-td {
  height: 45px;
}
.pwmat-trial-download-introduce-td:hover {
  background: rgba(73, 145, 201, 0.1);
}
.pwmat-trial-download-introduce-text-th {
  border: 1px solid rgba(240, 240, 240, 1);
  font-size: 16px;
  font-family: PingFangSC-Regular, sans-serif;
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
  line-height: 25px;
  padding-left: 16px;
}
.pwmat-trial-download-introduce-text-td {
  border: 1px solid rgba(240, 240, 240, 1);
  font-size: 16px;
  font-family: PingFangSC-Regular, sans-serif;
  font-weight: 400;
  line-height: 25px;
  padding: 16px;
}
.pwmat-trial-download-info-a {
  cursor: pointer;
}
.pwmat-trial-download-info-a:hover,
.pwmat-trial-download-info-a:active {
  text-decoration: underline;
}
.pwmat-trial-download-pre {
  background: rgba(73, 145, 201, 0.1);
  padding: 24px 32px;
}

@media screen and (max-width: 482px) {
  .pwmat-trial-download-container {
    max-width: 100%;
  }
}
@media screen and (min-width: 482px) and (max-width: 768px) {
  .pwmat-trial-download-container {
    max-width: 450px;
  }
}
@media screen and (min-width: 768px) and (max-width: 1100px) {
  .pwmat-trial-download-container {
    max-width: 736px;
  }
}
@media screen and (min-width: 1100px) and (max-width: 1444px) {
  .pwmat-trial-download-container {
    max-width: 1068px;
  }
}
@media screen and (min-width: 1444px) {
  .pwmat-trial-download-container {
    max-width: 1068px;
  }
}
</style>
